export default __webpack_public_path__ + "static/media/mobile.2c0f2178.jpg";